<script setup>
import AttachmentUploadPanel from '@/components/ui/AttachmentUploadPanel.vue'

defineProps({
  adapter: { type: Object, required: true },
  initialView: { type: String, default: 'form' },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' }
})
const emit = defineEmits(['closeModal', 'busyChange'])
</script>

<template>
  <v-card-modal>
    <AttachmentUploadPanel
      :adapter="adapter"
      :initial-view="initialView"
      :title="title"
      :subtitle="subtitle"
      @confirmed="emit('closeModal', $event)"
      @cancelled="emit('closeModal', $event)"
      @busy-change="emit('busyChange', $event)"
    >
      <template #additional-fields="slotProps"
        ><slot name="additional-fields" v-bind="slotProps"
      /></template>
    </AttachmentUploadPanel>
  </v-card-modal>
</template>
